import React from "react";
import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";
import { getPermisosPorCategoria } from "../../../../resources/Helper";
import Unauthorized from "../../general/Unauthorized";
import PermisosRolAcordeones, { PERMISOS_ROL_STYLES } from "../PermisosRolAcordeones";
import { buildPermisosRolSecciones, getAllPermissionIds } from "../permisosRolSecciones";

function EditarRol() {

    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState({});
    const [permissions, setPermissions] = useState([]);

    const [permisosPacientes, setPermisosPacientes] = useState([]);
    const [permisosFacturacion, setPermisosFacturacion] = useState([]);
    const [permisosContabilidad, setPermisosContabilidad] = useState([]);
    const [permisosGenerales, setPermisosGenerales] = useState([]);
    const [permisosAgenda, setPermisosAgenda] = useState([]);
    const [permisosAdministracion, setPermisosAdministracion] = useState([]);
    const [permisosPersonal, setPermisosPersonal] = useState([]);
    const [permisosReportes, setPermisosReportes] = useState([]);
    const [permisosIndicadores, setPermisosIndicadores] = useState([]);
    const [permisosConfiguracion, setPermisosConfiguracion] = useState([]);
    const [permisosLaboratorio, setPermisosLaboratorio] = useState([]);
    
    const [roleName, setRoleName] = useState('');
    const [roleDescription, setRoleDescription] = useState('');

    let history = useHistory();

    let userdata = [];
    const [rolep, setRolep] = useState([]);

    const addPermission = (permissionId) => {
        setRolep(prevPermissions => {
            let newPermissions = [...prevPermissions];
            let permissionIndex = newPermissions.indexOf(permissionId);
            
            if (permissionIndex > -1) {
                newPermissions.splice(permissionIndex, 1);
            } else {
                newPermissions.push(permissionId);
            }

            console.log('Updated permissions:', newPermissions);
            return newPermissions;
        });
    }

    // 🔄 Función para marcar/desmarcar todos los permisos de una sección
    const toggleAllPermissions = (sectionPermissions, sectionName) => {
        const sectionIds = sectionPermissions.map(p => p.id);
        const allSelected = sectionIds.every(id => rolep.includes(id));
        
        setRolep(prevPermissions => {
            let newPermissions = [...prevPermissions];
            
            if (allSelected) {
                // Desmarcar todos los de esta sección
                newPermissions = newPermissions.filter(id => !sectionIds.includes(id));
            } else {
                // Marcar todos los de esta sección
                sectionIds.forEach(id => {
                    if (!newPermissions.includes(id)) {
                        newPermissions.push(id);
                    }
                });
            }
            
            return newPermissions;
        });
    };

    // 🔍 Función para verificar si todos los permisos de una sección están seleccionados
    const areAllSectionPermissionsSelected = (sectionPermissions) => {
        const sectionIds = sectionPermissions.map(p => p.id);
        return sectionIds.length > 0 && sectionIds.every(id => rolep.includes(id));
    };

    const permisosSecciones = buildPermisosRolSecciones({
        permisosGenerales,
        permisosAdministracion,
        permisosAgenda,
        permisosPersonal,
        permisosReportes,
        permisosPacientes,
        permisosFacturacion,
        permisosContabilidad,
        permisosIndicadores,
        permisosConfiguracion,
        permisosLaboratorio,
    });

    const toggleAllGlobal = () => {
        const allIds = getAllPermissionIds(permisosSecciones);
        const allSelected = allIds.length > 0 && allIds.every((id) => rolep.includes(id));

        setRolep((prev) => {
            if (allSelected) {
                return prev.filter((id) => !allIds.includes(id));
            }
            const next = [...prev];
            allIds.forEach((id) => {
                if (!next.includes(id)) {
                    next.push(id);
                }
            });
            return next;
        });
    };

    const areAllGlobalSelected = () => {
        const allIds = getAllPermissionIds(permisosSecciones);
        return allIds.length > 0 && allIds.every((id) => rolep.includes(id));
    };

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a editar roles
        const tienePermiso = userdata.up && userdata.up.includes('administrarSeguridad');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    //console.log(response.data);
                    //console.log(JSON.stringify(client));

                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });
        

        /*axios.get('/permissions', config)
            .then(response => {
                if (response.status===200) {
                    setPermissions(response.data);
                    console.log(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
        */
        
        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/role',config2)
            .then(response => {
                setRoleName(response.data.name);
                setRoleDescription(response.data.description);
                setPermissions(response.data.permissions);

                //////////////////////////////

                setPermisosPacientes(getPermisosPorCategoria(response.data.permissions,'pacientes'));
                setPermisosGenerales(getPermisosPorCategoria(response.data.permissions,'general'));
                setPermisosFacturacion(getPermisosPorCategoria(response.data.permissions,'facturacion'));
                setPermisosContabilidad(getPermisosPorCategoria(response.data.permissions,'contabilidad'));
                setPermisosAgenda(getPermisosPorCategoria(response.data.permissions,'agenda'));
                setPermisosAdministracion(getPermisosPorCategoria(response.data.permissions,'administracion'));
                setPermisosPersonal(getPermisosPorCategoria(response.data.permissions,'personal'));
                setPermisosReportes(getPermisosPorCategoria(response.data.permissions,'reportes'));
                setPermisosIndicadores(getPermisosPorCategoria(response.data.permissions,'indicadores'));
                setPermisosConfiguracion(getPermisosPorCategoria(response.data.permissions,'configuracion'));
                setPermisosLaboratorio(getPermisosPorCategoria(response.data.permissions,'laboratorio'));

                //////////////////////////////
                
                let initialPermissions = [];
                for (let k=0;k<response.data.permissions.length;k++) {
                    let perm = response.data.permissions[k];
                    
                    if (perm.permission_id!=null) {
                        initialPermissions.push(perm.id);
                    }
                }

                setRolep(initialPermissions);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        /*if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }*/

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            id: id,
            client_id: client.client_id,
            name: roleName,
            description: roleDescription,
            permissions: JSON.stringify(rolep)
        };
        
        console.log(conf);

        axios.put('/role', conf)
            .then(
                response => {
                    setLoading(false);

                    history.push('/roles');
                }
            )
            .catch(
                err => {
                    setLoading(false);
                }
            )
    }

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <style>{PERMISOS_ROL_STYLES}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/security">Seguridad y Permisos</Link></li>
                                        <li className="breadcrumb-item" key="bc5"><Link to="/roles">Roles de usuario</Link></li>
                                        <li className="breadcrumb-item" key="bc6">Editar Rol</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Rol</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">
                                    
                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="roleName">Nombre <span className="text-danger">*</span></label>
                                                                <input type="text" name="name" className="form-control" id="roleName" value={roleName} onChange={(e) => setRoleName(e.target.value)} required disabled={loading} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="roleDescription">Descripción <span className="text-danger">*</span></label>
                                                                <input type="text" name="description" className="form-control" id="roleDescription" value={roleDescription} onChange={(e) => setRoleDescription(e.target.value)} disabled={loading} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <PermisosRolAcordeones
                                            idPrefix="editar-rol"
                                            sections={permisosSecciones}
                                            selectedIds={rolep}
                                            onTogglePermission={addPermission}
                                            onToggleSection={toggleAllPermissions}
                                            areAllSectionSelected={areAllSectionPermissionsSelected}
                                            onToggleAllGlobal={toggleAllGlobal}
                                            areAllGlobalSelected={areAllGlobalSelected}
                                        />

                                        <div className="d-flex gap-2" style={{margin: '30px 0 30px 8px'}}>
                                            <Link to="/roles" className="btn btn-secondary">
                                                Cancelar
                                            </Link>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                Guardar cambios&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                            </button>
                                        </div>
                                    </form>
                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarRol;